import { tranlateInvalidInputs, formatInputsOnMessage, is2xxStatus } from './AlertMessageLogic'

export default function messageOnSubmitEditedMiniAppInfo(status, invalidInputs) {
    let message, inputs

    invalidInputs = tranlateInvalidInputs(invalidInputs)
    inputs = formatInputsOnMessage(invalidInputs)

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos atualizar o eitri-app.'
            break
        case 'invalid':
            message = `Ops! Não atualizamos o eitri-app, verifique se os campos foram preenchidos corretamente. Campo(s) inválido(s): ${inputs}`
            break
        case '2xx':
            message = 'Atualizamos o eitri-app.'
            break
        case 400:
            message = 'Não atualizamos o eitri-app, verifique se você preencheu todas as informações.'
            break
        case 401:
            message = 'Ops! O seu tempo de acesso expirou, para editar o eitri-app é necessário realizar o login.'
            break
        case 403:
            message = 'Permissão Negada.'
            break
        case 500:
        default:
            message = 'Ops! Algo estranho ocorreu e não atualizamos o eitri-app. Por favor, tente novamente mais tarde.'
    }
    return message
}
